import type {
  EffectConfig,
  EffectParams,
  EffectPower,
  EffectSpinDirections,
  SchemaGroup,
} from '../types';
import {
  delay,
  durationLong,
  power,
  directionSpin as direction,
  easing,
} from './baseParams';

export interface Spin extends EffectParams {
  direction: EffectSpinDirections;
  power?: EffectPower;
}

const name = 'Spin';
const groups: SchemaGroup[] = ['ongoing', 'animation'];

export const config: EffectConfig<Spin> = {
  name,
  groups,
  schema: {
    delay: { ...delay },
    duration: { ...durationLong, default: 7000 },
    direction: { ...direction },
    power: { ...power, default: 'soft' },
  },
} as const;

export const responsiveConfig: EffectConfig<Spin> = {
  name,
  groups,
  schema: {
    delay: { ...delay },
    duration: { ...durationLong, default: 7000 },
    direction: { ...direction },
    easing: { ...easing, default: 'linear' },
  },
} as const;
